import './constants';

const SCRIM_RGB = {
  global: "38, 27, 18",
  umrah: "14, 23, 20",
  // The chooser has no hero photograph and no splash image; its glass is a different value.
  choice: "20, 14, 10"
};
const HERO_SCRIM_STOPS = [0.94, 0.5, 0.34];
const HERO_SCRIM_DIRECTION = {
  global: "to top",
  umrah: "105deg",
  choice: "to top"
};
function heroScrimCss(rgb, direction = "to top") {
  const [bottom, mid, top] = HERO_SCRIM_STOPS;
  return `linear-gradient(${direction}, rgba(${rgb}, ${String(bottom)}) 0%, rgba(${rgb}, ${String(mid)}) 46%, rgba(${rgb}, ${String(top)}) 100%)`;
}

export { HERO_SCRIM_DIRECTION, HERO_SCRIM_STOPS, SCRIM_RGB, heroScrimCss };
//# sourceMappingURL=scrim.js.map
//# sourceMappingURL=scrim.js.map